<template>
  <div v-if="authorised">
    <v-card class="mb-3">
      <v-card-title class="pa-0">
        <v-system-bar color="accent" dark window style="width: 100%">
          <v-btn flat @click="openDisk">{{ label }}<v-icon>{{diskOpen?'mdi-chevron-up':'mdi-chevron-down'}}</v-icon></v-btn>
          <v-spacer></v-spacer>
          <v-tooltip top>
            <input class="d-file-uploader__input" type="file" ref="file" @change="onChangeInputFile">
            <v-btn icon slot="activator" @click="selectInputFile('my')" class="mx-0">
              <v-icon class="mx-0 white--text">mdi-cloud-upload</v-icon>
            </v-btn>
            <span>Загрузить файл</span>
          </v-tooltip>
          <v-tooltip top>
            <v-btn icon slot="activator" @click="addNote(null, 'my')" class="mx-0">
              <v-icon class="mx-0 white--text">mdi-file-plus</v-icon>
            </v-btn>
            <span>Создать новый текстовый файл</span>
          </v-tooltip>
          <v-tooltip top>
            <v-btn icon slot="activator" @click="addElement($event, 'folder', null, 'my')" class="mx-0">
              <v-icon class="mx-0 white--text">mdi-folder-plus</v-icon>
            </v-btn>
            <span>Создать новую папку</span>
          </v-tooltip>
        </v-system-bar>
      </v-card-title>
      <v-card-text class="px-0 py-2 overflow-auto" v-show="diskOpen">
        <div class="text-sm-center">
          <v-progress-circular
            indeterminate
            color="primary"
            v-if="loading"
          ></v-progress-circular>
        </div>
        <v-treeview :items="data" activatable item-key="key" class="densed" :load-children="getFolderContent"
                    :active.sync="treeActive" :open.sync="treeOpen" v-if="!loading">
          <template slot="prepend" slot-scope="{ item, open }">
            <v-icon v-if="!item.mime" size="20">{{ open ? 'mdi-folder-open' : 'mdi-folder' }}</v-icon>
            <v-icon v-else size="20">{{ getIcon(item.mime) }}</v-icon>
            <v-icon size="16" class="ml-1 pointer" @click="showScopes(item)">{{getShareIcon(item)}}</v-icon>
          </template>
          <label slot="label" class="pointer" slot-scope="{item}" @click="itemClick(item, false, 'my')"
                  @contextmenu.prevent="openCtxMenu(item)">{{item.name}}</label>
        </v-treeview>
      </v-card-text>
    </v-card>

    <context-menu id="disk-context-menu" ref="localCtxMenu">
      <li @click="openInfoForm"><v-icon size="18">mdi-information</v-icon> Информация</li>
      <li @click="restoreElement" v-if="currentTree==='trashed' && currentElement && currentElement.writable"><v-icon size="18">mdi-restore</v-icon> Восстановить</li>
      <li @click="renameElement" v-if="currentTree!=='trashed' && currentElement && currentElement.writable"><v-icon size="18">mdi-cursor-text</v-icon> Переименовать</li>
      <li @click="openEditForm(true)" v-if="currentTree!=='trashed' && currentElement && currentElement.writable"><v-icon size="18">mdi-settings</v-icon> Настройки</li>

      <li @click="addElement($event, 'folder', currentElement.id, currentTree)" v-if="elementType==='folder' && currentTree!=='trashed' && currentElement && currentElement.writable"><v-icon size="18">mdi-folder-plus</v-icon> Добавить папку</li>
      <li @click="addNote(currentElement.id)" v-if="elementType==='folder' && currentTree!=='trashed' && currentElement && currentElement.writable"><v-icon size="18">mdi-file-plus</v-icon> Создать заметку</li>
      <li @click="selectInputFile(currentTree)" v-if="elementType==='folder' && currentTree!=='trashed' && currentElement && currentElement.writable"><v-icon size="18">mdi-cloud-upload</v-icon> Загрузить файл</li>
      
      <li @click="previewFile" v-if="elementType==='file'"><v-icon size="18">mdi-eye</v-icon> Просмотр</li>
      <li @click="downloadFile" v-if="elementType==='file'"><v-icon size="18">mdi-download</v-icon> Скачать</li>
      <li @click="deleteElement" v-if="currentElement && currentElement.writable"><v-icon size="18">mdi-delete</v-icon> Удалить</li>
    </context-menu>

    <v-menu :close-on-content-click="false" v-model="menu.show" offset-y bottom absolute :position-x=position.x :position-y="position.y">
      <v-card>
        <v-card-text class="py-1">
          <v-text-field :label="elementType==='folder'?'Название папки':'Название файла'" hide-details clearable v-model="elementName" @keypress.enter="saveElement"></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" flat @click="menu.show = false" small>Отмена</v-btn>
          <v-btn color="success" dark @click="saveElement" :disabled="!elementName">Сохранить</v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>

    <v-dialog v-model="dialog" max-width="1000" scrollable persistent>
      <component :is="currentComponent" v-if="dialog" v-bind="formProps" @close-dialog="dialog=false" @save="saveDialog"></component>
    </v-dialog>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import {getNodeByProp, deleteNodeByProp} from '@/helpers/tree'
  import httpClient from '@/api/http-client'
  import apiDisk from '@/apps/disk/api'
  import contextMenu from 'vue-context-menu'
  import InfoForm from './Forms/InfoForm'
  import FolderForm from './Forms/FolderForm'

  const cancelToken = httpClient.cancelToken

  export default {
    name: 'FolderItem',

    components: {
      contextMenu,
      InfoForm,
      FolderForm
    },
    
    props: {
      authorised: {
        type: Boolean
      },
      id: {
        type: Number
      },
      label: {
        type: String
      },
      diskType: {
        type: String
      },
      getFolderContent: {
        type: Function
      },
      getIcon: {
        type: Function
      },
      getShareIcon: {
        type: Function
      },
      showScopes: {
        type: Function
      },
      openHistoryForm: {
        type: Function
      },
    },

    created () {
      if (this.diskType === 'system') {
        this.openDisk()
        this.$emit('letData', this.data)
      }
    },
    computed: {
      ...mapGetters('app/helpers',['formatDatetime']),
    },
    data() {
      return {
        newEditor: false,
        diskOpen: false,
        loading: false,
        firstOpen: true,
        data: [],
        treeOpen: [],
        treeActive: [],
        currentTree: 'my',
        currentElement: null,
        fileContent: '',
        elementName: '',
        elementType: '',
        elementTree: '',
        editFile: null,
        preview: null,
        previewElement: null,
        menu: {
          show: false,
          action: null,
          folder_id: null
        },
        position: {x: null, y: null},
        dialog: false,
        currentComponent: ''
      }
    },
    methods: {
      openDisk() {
        if (!this.diskOpen && this.firstOpen) {
          this.loading = true
          this.diskOpen = true
          this.firstOpen = false
          this.$store.dispatch('disk/diskFiles', this.id).then(response => {
            this.data = response
            this.loading = false
          })
        } else if (!this.diskOpen && !this.firstOpen) {
          this.diskOpen = true
        } else if (this.diskOpen) {
          this.diskOpen = false
        }
      },
      saveDialog(eventData){
        switch(eventData.type){
          case 'addFile':
            this.addFile(eventData.data)
            break
          case 'saveFile':
            this.saveFile(eventData.data, eventData.change_owner)
            break
          case 'saveFolder':
            this.saveFolder(eventData.data, eventData.change_owner)
            break
          case 'scopes':
            this.saveScopes(eventData.data, eventData.count)
            break
          case 'change-history':
            this.changeVersion()
            break;
        }
        if(!eventData.dialog===true) this.dialog = false
      },
      previewFile(){
        this.editFile = false
        this.preview = true
        this.previewElement = JSON.parse(JSON.stringify(this.currentElement))
      },

      saveFolder (folder, changeOwner) {
      let tree = null
      switch (this.currentTree) {
        case 'my': tree = this.data; break
        case 'shared': tree = this.shared_files; break
        case 'trashed': tree = this.trashed_files; break
        default: tree = this.data; break
      }

      if (changeOwner) {
        deleteNodeByProp('key', 'directory_' + folder.id, tree)
      } else {
        folder.children = this.currentElement.children
        // Если родитель не менялся - Обновить данные
        if (this.currentElement.parent === folder.parent) {
          Object.assign(this.currentElement, folder)
        } else {
          // Если менялся родитель: Перенести, если папка уже видна. Если не видна - удалить текущую. Если null - втставить в корень
          deleteNodeByProp('key', 'directory_' + folder.id, tree)
          if (folder.parent != null) {
            let newParent = getNodeByProp('key', 'directory_' + folder.parent, tree)
            if (newParent != null) {
              let index = newParent.children.length
              newParent.children.some((el, i) => {
                if (el.key.indexOf('file') > -1) {
                  index = i
                  return true
                }
              })
              newParent.children.splice(index, 0, folder)
            }
          } else {
            let index = tree.length
            tree.some((el, i) => {
              if (el.key.indexOf('file') > -1) {
                index = i
                return true
              }
            })
            tree.splice(index, 0, folder)
          }
        }
      }
    },

      downloadFile(){
        if(this.currentElement.token){
          let url = '/disk/d/'+this.currentElement.token
          let anchor = document.createElement('a');
          anchor.href = url;
          anchor.target = '_blank';
          anchor.download = this.currentElement.name;
          anchor.click();
        } else {
          this.$dmsErrorNoty('Ошибка. Невозможно скачать файл.')
        }
      },
      openInfoForm(){
        this.formProps = {
          data: this.currentElement,
          type: this.elementType
        }
        this.currentComponent = InfoForm
        this.dialog = true
      },
      openEditForm(editMode){
        let tree = this.data
        
        this.formProps = {
          isFolder: editMode && this.elementType==='folder',
          editMode: editMode
        }
        //EditMode = false может быть только у файла
        if(editMode===false){
          this.formProps.data = {
            name : '',
            directory: this.currentElement.id,
            dir_name: this.currentElement.name
          }
        } else {
          this.formProps.data = this.currentElement
          let key = (this.elementType==='folder') ? this.currentElement.parent : this.currentElement.directory
          let node = getNodeByProp('key', 'directory_'+key, tree)
          if(node!=null){
            this.formProps.data.dir_name = node.name
          }
        }
        this.currentComponent = FolderForm
        this.dialog = true
      },
      openCtxMenu(item, treeType){
        if(treeType) this.currentTree = treeType
        this.currentElement = item
        this.treeActive = [item.key]
        this.elementType = (item.key.indexOf('directory')>-1) ? 'folder' : 'file'
        this.$refs.localCtxMenu.open()
      },
      addNote(folder_id, treeType){
        this.currentTree = treeType
        this.elementName = 'Новая заметка от '+this.formatDatetime().short
        this.elementType = 'file'
        let tree = this.data
        let node = getNodeByProp('key', 'directory_'+folder_id, tree)
        if(folder_id){
          this.getFolderContent(node).then( () => {
            this.createElement(folder_id, true)
            this.editFile = true
            this.fileContent = ''
          })
        } else {
          this.createElement(folder_id, true)
          this.editFile = true
          this.fileContent = ''
        }
      },
      
      addElement(event, type, folder_id = null, treeType){
        this.currentTree = treeType
        this.position = { x: event.x, y: event.y}
        this.elementName = (type==='folder') ? 'Новая папка' : 'Новая заметка от '+this.formatDatetime().short
        this.menu = {
          show: true,
          action: 'add',
          folder_id: folder_id
        }
        this.elementType = type
      },
  
      renameElement(event){
        this.position = { x: event.x-50, y: event.y-66}
        this.elementName = this.currentElement.name
        this.menu = {
          show: true,
          action: 'rename',
          folder_id: null
        }
      },

      itemClick(item, newCrumb = false, treeType){
        this.$emit('letData', this.data)
        const clickableItem = {
          item,
          newCrumb,
          treeType
        }
        this.$emit('itemClickEmit', clickableItem)
      },
      
      saveElement(){
        switch(this.menu.action){
          case 'add':
            this.createElement(this.menu.folder_id)
            break
          case 'rename':
            this.updateName()
            break
        }
        this.menu.show = false
      },
  
      saveFileName(){
        let data = {
          id: this.currentElement.id,
          name: this.currentElement.name
        }
        this.$store.dispatch('disk/updateFile', data).catch( error => {
          this.$dmsErrorNoty('Возникла ошибка при попытке изменить имя')
        })
      },

      saveFile(file, change_owner){
        let tree = this.data
        if(change_owner){
          deleteNodeByProp('key', 'file_'+file.id, tree)
        } else {
          if(this.currentElement.directory === file.directory){
            Object.assign(this.currentElement, file)
          } else {
            deleteNodeByProp('key', 'file_'+file.id, tree)
            if(file.directory!=null){
              let newParent = getNodeByProp('key', 'directory_'+file.directory, tree)
              if(newParent!=null){
                newParent.children.push(file)
              }
            } else {
              tree.push(file)
            }
          }
        }
      },
      
      createElement(folder_id, makeCurrent = false){
        let tree = this.data
        
        if(this.elementType==='file'){
          let formData = new FormData();
          let blob = new Blob([""], { type: "text/html"});
          formData.append("file", blob);
          formData.append("name", this.elementName);
          formData.append('volume', this.id)
          if(folder_id) {
            formData.append('directory', folder_id)
          }
          this.$store.dispatch('disk/uploadFile', formData).then( response => {
            if(folder_id) {
              let node = getNodeByProp('key', 'directory_'+folder_id, tree)
              if(node!=null){
                node.children.push(response)
                if(makeCurrent) {
                  this.treeActive = [response.key]
                  this.$emit('makeCurrentElement', response, this.data) 
                }
              }
            } else {
              tree.push(response)
              if(makeCurrent) {
                this.treeActive = [response.key]
                this.$emit('makeCurrentElement', response, this.data)
              }
            }
          }).catch( error => {
            console.log(error)
            this.$dmsErrorNoty('Возникла ошибка при попытке создать заметку')
          })
        } else {
          let data = { 
            name: this.elementName,
            volume: this.id
          }
          if(folder_id) {
            data.parent = folder_id
          }
          this.$store.dispatch('disk/createFolder', data).then( response => {
            //Вставить папку после всех папок в корне или папке, перед файлами
            if(folder_id) {
              let node = getNodeByProp('key', 'directory_'+folder_id, tree)
              if(node!=null){
                let index = node.children.length
                node.children.some( (el, i) => {
                  if(el.key.indexOf('file')>-1){
                    index = i
                    return true
                  }
                })
                node.children.splice(index, 0, response)
              }
            } else {
              let index = tree.length
              tree.some( (el, i) => {
                if(el.key.indexOf('file')>-1){
                  index = i
                  return true
                }
              })
              tree.splice(index, 0, response)
            }
          }).catch( error => {
            this.$dmsErrorNoty('Возникла ошибка при попытке создать папку')
          })
        }
      },
      
      updateName(){
        let tree = null
        switch(this.currentTree){
          case 'my': tree = this.data; break
          case 'shared': tree = this.shared_files; break
          case 'trashed': tree = this.trashed_files; break
          default: tree = this.data; break
        }
        
        let data = {
          id: this.currentElement.id,
          name: this.elementName
        }
        
        if(this.elementType==='folder'){
          this.$store.dispatch('disk/updateFolder', data).then( _ => {
            let node = getNodeByProp('key', this.currentElement.key, tree)
            if(node) node.name = this.elementName
          }).catch( error => {
            this.$dmsErrorNoty('Возникла ошибка при попытке изменить имя')
          })
        } else if(this.elementType==='file'){
          this.$store.dispatch('disk/updateFile', data).then( _ => {
            let node = getNodeByProp('key', this.currentElement.key, tree)
            if(node) node.name = this.elementName
          }).catch( error => {
            this.$dmsErrorNoty('Возникла ошибка при попытке изменить имя')
          })
        }
      },
      
      deleteElement(){
        let tree = this.data
        
        if(this.elementType==='folder'){
          this.$dmsAgree('Вы действительно хотите удалить папку. Вложенные папки и файлы также будут удалены?').then(_ => {
            this.$store.dispatch('disk/deleteFolder', this.currentElement.id).then( _ => {
              let node = deleteNodeByProp('key', this.currentElement.key, tree)
              if(this.currentTree==='my' && node!=null) this.$emit('pushFolderToTrash', node)
            }).catch( error => {
              this.$dmsErrorNoty('Возникла ошибка при попытке удалить папку')
              console.log(error)
            })
          })
        } else if(this.elementType==='file'){
          this.$dmsAgree('Вы действительно хотите удалить файл?').then(_ => {
            this.$emit('deleteElementEmit', this.currentElement.id)
            this.$store.dispatch('disk/deleteFile', this.currentElement.id).then( _ => {
              let node = deleteNodeByProp('key', this.currentElement.key, tree)
              if(this.currentTree==='my' && node!=null) this.$emit('pushToTrash', node)
            }).catch( error => {
              this.$dmsErrorNoty('Возникла ошибка при попытке удалить файл')
              console.log(error)
            })
          })
        }
      },

      selectInputFile(tree) {
        this.currentTree = tree
        if (this.$refs && this.$refs.file) {
          this.$refs.file.click()
        }
      },
  
      onChangeInputFile(e){
        let files = e.target.files || e.dataTransfer.files
        if (!files.length) return
        let formData = new FormData
        formData.append("file", files[0]);
        formData.append('name', files[0].name)
        formData.append('volume', this.id)
        if(this.currentElement && this.currentElement.key.indexOf('directory')>-1){
          formData.append('directory', this.currentElement.id)
        }
        this.loadingDialog = true

        this.cancelTokenSource = cancelToken.source()
        apiDisk.uploadFile(formData, this.cancelTokenSource.token).then( response => {
          this.addFile(response)
        }).catch( error => {
          let message = (error.message && error.message.length>0) ? error.message : 'Ошибка загрузки файла'
          this.$dmsErrorNoty(message)
        }).finally( _ => {
          this.loadingDialog = false
          this.cancelTokenSource = null
        })
      },
  
      cancelFileUploading(){
        this.cancelTokenSource.cancel('Загрузка файла отменена пользователем')
        this.loadingDialog = false
        this.cancelTokenSource = null
      },

      addFile(file){
        let tree = this.data
        
        if(file.directory!=null){
          let newParent = getNodeByProp('key', 'directory_'+file.directory, tree)
          if(newParent!=null){
            newParent.children.push(file)
          }
        } else {
          tree.push(file)
        }
      },
    },
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/apps/disk/components/Folders/FolderItem.vue